<template>
  <div id="return_step_3">
    <div class="price_wrap">
      <div class="left_box">
        <div class="box_top">
          <span>{{ `취소상품 총 금액 합게` }}</span>
        </div>
        <div class="price">
          <span>{{ `000000원` }}</span>
        </div>
        <div class="desc">
          <div>{{ `취소상품합계 : 12,600원` }}</div>
          <div>{{ `취소 배송비 합계 : 3,500원` }}</div>
        </div>
      </div>
      <div class="box_emt">
        <div class="line_mt"></div>
      </div>
      <div class="middle_box">
        <div class="box_top">
          <span>{{ `환불금액 차감내역` }}</span>
        </div>
        <div class="price">{{ `2,500원` }}</div>
        <div class="desc">
          <div>{{ `박스개수 : 1개` }}</div>
          <div>{{ `배송비 추가금액 : 3,500원` }}</div>
        </div>
      </div>
      <div class="box_emt">
        <div class="line_mt"></div>
        <div class="line_mt"></div>
      </div>
      <div class="right_box">
        <div class="box_top">
          <span>{{ `환불 예정금액` }}</span>
        </div>
        <div class="price">
          {{ `38,500원` }}
        </div>
        <div class="desc">
          <div>{{ `신용카드 환불금액 : 5,600원` }}</div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="stage_btn_wrap">
      <div class="prev_btn cursor" @click="$emit('prevCall', 2)">이전으로</div>
      <div class="next_btn cursor" @click="emitCall">반품 요청 완료</div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  computed: {},
  methods: {
    async emitCall() {
      this.$emit('nextCall', {
        stageNo: 3,
        stageVal: {}
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.stage_btn_wrap {
  display: flex;
  justify-content: center;
  padding: 40px 0px 64px;
  border-top: 1px solid #d6e7f1;
  div {
    background-color: #778899;
    width: 240px;
    height: 48px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
  }
  div + div {
    margin-left: 8px;
    background-color: #125c83;
  }
}
.price_wrap {
  margin: 24px 0px 40px;
  width: 100%;
  height: 205px;
  display: flex;
  justify-content: space-between;
  padding: 40px 60px;
  align-items: center;
  background-color: #f0f5fa;
}
.box_emt {
  width: 24px;
  height: 24px;
  background-color: #ffffff;
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 6px;
  .line_mt {
    width: 100%;
    height: 2px;
    background-color: #778899;
  }
}
.left_box,
.middle_box,
.right_box {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: right;
}
.box_top {
  font-size: 16px;
  font-weight: 500;
  color: #778899;
  height: 24px;
  line-height: 24px;
}
.price {
  font-size: 28px;
  font-weight: 600;
  color: #000000;
  margin: 0 !important;
  height: 24px;
  line-height: 24px;
}
.desc {
  font-size: 12px;
  font-weight: 500;
  color: #777777;
  line-height: 15px;
  border-top: 1px solid #d6e7f1;
  padding-top: 12px;
  div {
    min-height: 15px;
  }
}
.right_box {
}
</style>
